// Firebase configuration
// Baseado no projeto 'novovirtualcart' e app 'financeiro-frontend'
export const firebaseConfig = {
  apiKey: 'AIzaSyCqshWHhrk7097BmNfTpEYFbyf3qfY8w34',
  authDomain: 'novovirtualcart.firebaseapp.com',
  projectId: 'novovirtualcart',
  storageBucket: 'novovirtualcart.firebasestorage.app',
  messagingSenderId: '164528833314',
  appId: '1:164528833314:web:1ace33812e2e5a2c151b7b',
  measurementId: 'G-9151TZEWHT',
}

// VAPID Key para push notifications
// Obtenha em: Firebase Console > Project Settings > Cloud Messaging > Web Push certificates
export const vapidKey = 'BOGx4F3CZrzz9gzmY9jD0oAujrLBJoNCSx91KtFBaQLoktSM8X6Gu55FWdHBo774Xg-i_FBLpSgPMAe9C2j-gOQ'

// Configurações de notificação
export const notificationConfig = {
  icon: '/icon-192x192.png',
  badge: '/icon-72x72.png',
  defaultTitle: 'Financeiro - Notificação',
  defaultBody: 'Você tem uma nova notificação',
  vibrate: [200, 100, 200],
  requireInteraction: false,
  silent: false,
}

// URLs de redirecionamento
export const notificationRoutes = {
  atividades: '/atividades',
  receitas: '/receitas',
  despesas: '/despesas',
  default: '/',
}
